var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('payment-table',_vm._b({staticClass:"credit-card-payment-table",attrs:{"items":_vm.items,"columns":_vm.columns},on:{"infinite-scroll":function($event){return _vm.$emit('infinite-scroll')}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('credit-card-payment-item',{key:item.uuid,attrs:{"data":item}})]}}])},'payment-table',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }